<template>
    <div class="news">
       <div class="title wow fadeInUp">
            <p>{{$t('home').news.text0}}</p>
           <p>{{$t('home').news.text1}}</p>
       </div>
        <div class="allItems wow">
            <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
                <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                    <div class="one" @click="gotoInfo(item.id)">
                        <p style="display: none">0{{index+1}}</p>
                        <p>{{item.title}}</p>
                        <p>{{item.posttime | formatDate}}</p>
                        <p v-html="item.description"></p>
                        <div class="dots">
                            <span></span><span></span><span></span>
                        </div>
                        <div class="img">
                            <img :src="`//www.dhkbearing.com/${item.picurl}`" alt="">
                        </div>
                        <div class="btns">
                            {{$t('home').news.text2}}
                            <i class="el-icon-caret-right"></i>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <swiper :options="swiperOptionTop2" class="gallery-top gallery-top2" ref="swiperTop2">
                <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                    <div class="one" @click="gotoInfo(item.id)">
                        <p style="display: none">0{{index+1}}</p>
                        <p>{{item.title}}</p>
                        <p>{{item.posttime | formatDate}}</p>
                        <p v-html="item.description"></p>
                        <div class="dots">
                            <span></span><span></span><span></span>
                        </div>
                        <div class="img">
                            <img :src="`//www.dhkbearing.com/${item.picurl}`" alt="">
                        </div>
                        <div class="btns">
                            {{$t('home').news.text2}}
                            <i class="el-icon-caret-right"></i>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="btns">
                <div class="btn prev ">
                    <img src="../assets/zy/jt.png" alt="">
                </div>
                <div class="btn next ">
                    <img src="../assets/zy/jt.png" alt="">
                </div>
            </div>
            <div class="swiper-pagination" slot="pagination"></div>
        </div>
    </div>
</template>

<script>
    import {getProductsUrl} from '../util/lang'
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        name: "news",
        data(){
            return{
                swiperOptionTop: {
                    notNextTick: true,
                    slidesPerView:3,//一行显示3个
                    speed:1000,
                    init:false,
                    loop:false,
                    spaceBetween :100,
                    setWrapperSize :true,
                    autoplay: false,
                    navigation: {
                        prevEl: '.allItems .btn.prev',
                        nextEl: '.allItems .btn.next',
                    },
                    pagination: {
                        el: '.allItems .swiper-pagination',
                        clickable: true
                    }
                },
                swiperOptionTop2: {
                    notNextTick: true,
                    slidesPerView:1,//一行显示3个
                    speed:1000,
                    init:false,
                    loop:false,
                    spaceBetween :100,
                    setWrapperSize :true,
                    autoplay: false,
                    navigation: {
                        prevEl: '.allItems .btn.prev',
                        nextEl: '.allItems .btn.next',
                    },
                    pagination: {
                        el: '.allItems .swiper-pagination',
                        clickable: true
                    }
                },
                list:[]
            }
        },
        filters: {
            formatDate: function (value) {
                value=parseInt(value)*1000
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? ('0' + MM) : MM;
                let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();
                h = h < 10 ? ('0' + h) : h;
                let m = date.getMinutes();
                m = m < 10 ? ('0' + m) : m;
                let s = date.getSeconds();
                s = s < 10 ? ('0' + s) : s;
                return y + '-' + MM + '-' + d + ' ' ;
            }
        },
        components:{swiper, swiperSlide},
        mounted(){
            this.$nextTick(()=>{
                if(this.$i18n.locale==='en'){
                    this.getCom('119')
                }else{
                    this.getCom('19')
                }

            })
        },
        methods:{
            gotoNews(){
                const link='/news.html'
                window.open(link,'_self')
            },
            getCom(id){
                this.$nextTick(()=>{
                    const url = `${getProductsUrl(id)}`
                    this.$axios.get(url).then(res => {
                        res.data.data.map((item)=>{
                            if(item.flag=="c"){
                                this.list.push(item)
                            }
                        })
                        this.$refs.swiperTop.swiper.init()
                        this.$refs.swiperTop2.swiper.init()
                    })
                })
            },
            gotoInfo(id){
                const link=`/newsInfo2.html?id=${id}`
                window.open(link,'_blank')
            }
        }
    }
</script>

<style lang="scss" scoped>
.news{
    width:1440px;
    margin: 60px auto;
    animation-duration:2s;
    .title{
         width:100%;
        text-align: center;
        p:nth-child(1){
            font-family: "DINEngschriftStd";
            font-size: 50px;
            text-transform: uppercase;
            color:#333333;
        }
        p:nth-child(2){
            font-family: "SourceHanSansSC-Regular";
            font-size: 25px;
            color:#333333;
            margin: 30px auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            &::after{
                content:'';
                display: inline-block;
                width:22px;
                height:5px;
                background:rgba(253,204,73,1);
                margin-top: 40px;
            }
        }
    }
    .allItems{
        width:100%;
        position: relative;
        padding: 60px 0;
        animation:polygon 1s  forwards linear  ;
        .gallery-top{
            width:80%;
            margin: 0 auto;
            .item{
                .one{
                    cursor: pointer;
                    p:nth-child(2){
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        height:22px;
                    }
                    p:nth-child(1), p:nth-child(2){
                        font-family: "Microsoft YaHei UI";
                        font-size: 18px;
                        margin-top: 8px;
                        transition: all  600ms;
                    }
                    p:nth-child(3){
                        font-size: 12px;
                        font-family: "Microsoft YaHei UI";
                        color:#A6A6A6;
                        margin-top: 8px;
                    }
                    p:nth-child(4){
                        color:#919191;
                        font-size: 13px;
                        line-height: 24px;
                        font-family: "Microsoft YaHei UI";
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        height:48px;
                       margin: 15px auto;
                    }
                    .dots{
                        width:100%;
                        display: flex;
                        flex-direction: row;
                        span{
                            display: inline-block;
                            height:8px;
                            width:8px;
                            border-radius: 50%;
                            background-color: #919191;
                        }
                        span:not(:first-child){
                            margin-left: 5px;
                        }
                    }
                    .img{
                        width:95%;
                        overflow: hidden;
                        margin: 20px 0;
                        img{
                            width:100%;
                            display: block;
                            object-fit: cover;
                            transition: all  600ms;
                        }
                    }
                    .btns{
                        // border: 1px solid #F6C02E;
                        text-align: center;
                        padding: 10px  10px;
                        border-radius: 5px;
                        font-size: 14px;
                        display: inline-block;
                        transition: all 600ms;
                    }
                    &:hover{
                        p:nth-child(1), p:nth-child(2){
                            color:#FECE4A;
                        }
                        .img{
                            img{
                                transform: scale(1.2);
                            }
                        }
                        .btns{
                            border-color: transparent;
                            color:#FECE4A;
                        }
                    }
                }
            }
        }
        .gallery-top2{
            display: none;
        }
        .prev{
            position: absolute;
            left:0;
            top:45%;
            width:50px;
            height:45px;
            border:1px solid rgba(215, 215, 215, 1);
            text-align: center;
            cursor: pointer;
            transition: all 1s;
            z-index: 1000;
            img{
                margin-top: 18px;
                transform: translateX(20px);
            }
            &::before{
                content:'';
                height:100%;
                width:0;
                left:0;
                top:0;
                background-color:#FDCC49;
                position: absolute;
                transition: all 600ms;
            }
            &:hover{
                &::before{
                    width:100%;
                }
            }
        }
        .next{
            position: absolute;
            top:45%;
            right:0;
            width:50px;
            height:45px;
            border:1px solid rgba(215, 215, 215, 1);
            text-align: center;
            cursor: pointer;
            transition: all 1s;
            transform: rotateY(180deg);
            z-index: 1000;
            img{
                margin-top: 18px;
                transform: translateX(20px);
            }
            &::before{
                content:'';
                height:100%;
                width:0;
                left:0;
                top:0;
                background-color: #FDCC49;
                position: absolute;
                transition: all 600ms;
            }
            &:hover{
                &::before{
                    width:100%;
                }
            }
        }
        .btn:focus{
            outline: none;
        }
    }
    @keyframes transition1 {
        0% {
            transform: translate(-100px,100px);
            opacity: 0;
        }
        100% {
            transform: translate(0,0);
            opacity: 1;
        }
    }
    @keyframes transition2 {
        0% {
            transform: translate(100px,-100px);
            opacity: 0;
        }
        100% {
            transform: translate(0,0);
            opacity: 1;
        }
    }
    @keyframes polygon {
        0% {
            clip-path: polygon(0 0,0 100%,0 100%,0 0);
            opacity: 0;
        }
        100% {
            clip-path: polygon(0 0,0 100%,100% 100%,100% 0);
            opacity: 1;
        }
    }
    @media screen and (max-width: 1440px){
        width:90%;
    }
    @media screen and (max-width: 1000px){
    .title{
        p:nth-child(1){
            font-size: 32px;
        }
    }
        .allItems{
            padding: 0;
            .gallery-top{
                display: none;
            }
            .gallery-top2{
                display: block;
            }
            .prev,.next{
                top:35%;
            }
        }
    }
}
</style>
<style scoped>
    .news .swiper-pagination {
        bottom: 0;
        width: 100%;
        left:0;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .news .swiper-pagination>>>.swiper-pagination-bullet {
        font-size: 16px;
        font-family: "SOURCEHANSANSCN-BOLD";
        background-color: rgba(0,0,0,.2);
        margin-top: 20px;
        width:48px;
        height:1px;
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 50px;
        margin-left: 30px;
        text-align: center;
        position: relative;
        color:transparent;
        transition: all 600ms;
        opacity: 1;
    }
    .news .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .news .swiper-pagination>>>.swiper-pagination-bullet-active{
      background-color: #FECE4A;
    }
</style>
